$(document).ready(function(){
  // set variant key with value addon
  // check if page is particular product
  // get selected variant value
  // hide  addons
  // displlay add ons for selected variant

  if(window.location.href.toString().indexOf("rak7289-8-16-channel-outdoor-lorawan-gateway") > -1){
    displayAddonBySelection();
  }
  // if(window.location.href.toString().indexOf("wisgate-connect-base-kit-rak7391") > -1){
  //   disableAddonBySelection();
  // }

  function displayAddonBySelection(){
    let vk = {
      "EU868":["863-870MHz","858-878MHz"],
      "RU864":["863-870MHz","858-878MHz"],
      "IN865":["863-870MHz","858-878MHz"],
      "AS923":["902-928MHz","900-930MHz"], 
      "US915":["902-928MHz","900-930MHz"], 
      "AU915":["902-928MHz","900-930MHz"],
      "KR920":["902-928MHz","900-930MHz"],
      "EU433":["433MHz"],
      "CN470":["470MHz", "470-510MHz"]
    }
    $("#ProductSelect-product-template-option-2").on("change",function(){

      // eg. AS923
      let selected_variant = this.value

      // hide all addon that is on vk
      $(".sg-pro-access-product").each(function(){
        let product_name = $(this).find(".sg-pro-access-product-title").text()
        
        let un = [...new Set(Object.values(vk).flat())]
          
        un.forEach(e => {
          if(product_name.toLowerCase().indexOf(e.toLowerCase()) > -1){
            $(this).hide()
          }
        })
      })

      // loop through all addons to display
      $(".sg-pro-access-product").each(function(){

        //get addon title
        let product_name = $(this).find(".sg-pro-access-product-title").text()
        
        // array values selected variant
        let v = vk[selected_variant] 

        // loop through array
        v.forEach(e=>{
          // e is the value of frequency
          if(product_name.toLowerCase().indexOf(e.toLowerCase()) > -1){
            //if match
            //show
            $(this).show()
          }  
          
        })
        
      })
    })
  }

  function disableAddonBySelection(){

    console.log("disable addon")
    //selection
    let selection_target="outdoor"
    let to_disable_targets = [
      "1000M POE Injector | RP025-4800500YG-098-001"
    ]

    //if selected is change
    $("#ProductSelect-product-template-option-2").on("change",function(){

      //selected option
      let selected_variant = this.value

      // show all products after change
      $(".sg-pro-access-product").css({"opacity":"1","pointer-events":"auto"})
      
      if(selected_variant.toLowerCase().indexOf(selection_target) > -1){
        $(".sg-pro-access-product").each(function(){
          let product_name = $(this).find(".sg-pro-access-product-title").text()
          // array values selected variant
          let v = to_disable_targets
  
          // loop through array
          v.forEach(e=>{
            
            // e is the name of product to be disabled
            if(product_name.toLowerCase().indexOf(e.toLowerCase()) > -1){
              //if match
              //disable
              $(this).css({"opacity":".5","pointer-events":"none"})
            }
            
          })
          //endloop
          
        })
      }
     


      
    })
  }
  
})